import { ApolloProvider } from "@apollo/client";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { UserCacheProvider } from "./context/UserCacheContext";
import "./index.css";
//import reportWebVitals from "./reportWebVitals";
import graphQLClient from "./services/gqlClients";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { IOSNotificationProvider } from "./hooks/useIOSNotification";
import * as Sentry from "@sentry/react";
import ErrorFallbackComponent from "./components/ErrorFallbackComponent";
import { hasAnalyticsConsent, grantAnalyticsConsent } from "./services/cookieConsent";

// Initialize Sentry only in production
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://3c0b539ca39664e7dba45281bde8d3a7@o348659.ingest.us.sentry.io/4508414264082432",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1, // 10% of transactions for performance
    replaysSessionSampleRate: 0.1, // 10% of sessions
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
    environment: "production",
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Only initialize GTM/GA4 + Meta Pixel if the user already granted consent
// on a previous visit. Otherwise they stay off until the cookie banner's
// "Accetta" button calls grantAnalyticsConsent() (see CookieConsentBanner.tsx).
if (hasAnalyticsConsent()) {
  grantAnalyticsConsent();
}

if (process.env.NODE_ENV === "production") {
  //console.log = function () {}; // Disable console.log in production
}

if ("serviceWorker" in navigator) {
  serviceWorkerRegistration.register({
    onSuccess: (registration) => {
      console.log("Service Worker registration successful");
    },
    onError: (error) => {
      console.error("Service Worker registration failed:", error);
    },
    onUpdate: (registration) => {
      console.log("Service Worker update available");
      try {
        // Notify the app that an update is available so it can show a non-disruptive banner
        window.dispatchEvent(
          new CustomEvent("sw-update-available", { detail: { registration } })
        );
      } catch (e) {
        console.error("Error dispatching sw-update-available event:", e);
      }
    },
  });
}

window.addEventListener("beforeunload", () => {
  console.log("Unloading window");
  window.isUnloading = true;
});

// Use StrictMode in development for better debugging
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallbackComponent />}>
      <ApolloProvider client={graphQLClient}>
        <IOSNotificationProvider>
          <UserCacheProvider>
            <App />
          </UserCacheProvider>
        </IOSNotificationProvider>
      </ApolloProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
